import { ReactElement } from 'react';
import BadgeDot, { BadgeStatus, statusColorMap } from '../badge-dot/BadgeDot';
import styles from './CustomNotification.module.scss';
import { VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';

export interface CustomNotificationProps {
  title: string | ReactElement;
  message: string | ReactElement;
  badgeStatus: BadgeStatus;
  icon?: string;
  tooltipLabel?: string;
}

export const CustomNotification = ({
  title,
  message,
  badgeStatus,
  icon,
  tooltipLabel,
}: CustomNotificationProps): ReactElement => {
  return (
    <div
      className={styles.notification}
      style={{ '--cas-notification-color': statusColorMap[badgeStatus] } as React.CSSProperties}
    >
      {icon ? (
        <VdsIcon svgIcon={icon} style={{ fill: 'var(--cas-notification-color)' }} size="24px" />
      ) : (
        <BadgeDot status={badgeStatus} />
      )}
      <div className={styles.notification__title}>{title}</div>
      <div className={styles.notification__message}>{message}</div>
      {tooltipLabel && (
        <VdsTooltip
          id="custom-notification-tooltip"
          event="hover"
          max-width="calc(100% - 4rem)" // Ensure tooltip is constrained to fit the container, without covering the tooltip icon trigger.
          position="left"
          type="standard"
          text={tooltipLabel}
        >
          <VdsIcon
            slot="tooltip-trigger"
            svgIcon="information"
            size="20px"
            color="color-icon-high"
          />
        </VdsTooltip>
      )}
    </div>
  );
};

export default CustomNotification;
